// export const PTO_ADS_IMAGE_WIDTH = 640;
export const PTO_ADS_IMAGE_WIDTH = 340;
// export const PTO_ADS_IMAGE_HEIGHT = 930;
export const PTO_ADS_IMAGE_HEIGHT = 430;

export const BACKDROP_TRANSITION_DURATION_MS = 200;
export const MODAL_CLOSE_COUNTDOWN_SEC = 12;
